// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SymbolsBase_wrapper_vq10U","breadcrumbs":"SymbolsBase_breadcrumbs_3muam","description":"SymbolsBase_description_15f66","symbols":"SymbolsBase_symbols_2suoU"};